// utils/api.ts

import { ReviewEntry } from '../types';

const proxy = ''; // No longer used, but keeping empty string just in case refs needed cleanup or partial migration

export async function fetchReviews(markerID: string, offset: number = 0): Promise<ReviewEntry[]> {
  const url = '/api/proxy-reviews';

  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ markerID, offset })
    });
    const data = await res.json();
    return data.reviews || [];
  } catch (err) {
    console.error('Review fetch failed:', err);
    return [];
  }
}

export async function postReview(siteID: string, text: string, stars: number = 5) {
  const payload = {
    siteID,
    text,
    stars,
    user: { name: 'Anonymous' },
    review: {
      date: new Date().toISOString().split('T')[0],
      text,
      rating: { score: stars }
    }
  };

  try {
    await fetch('/api/doggle-review', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
  } catch (err) {
    console.error('Failed to submit review:', err);
  }
}

export async function fetchPlaces(term: string) {
  const apiUrl = '/api/places-search';

  try {
    const res = await fetch(apiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ term })
    });
    const data = await res.json();
    const placesObj = data.tblAllPlaces || {};
    return Object.values(placesObj)
      .filter((p: any) => p.c === 'gb')
      .map((p: any) => {
        const [lat, lng] = (p.l || '0,0').split(',').map(Number);
        return { name: p.t, lat, lng };
      });
  } catch (err) {
    console.error('Place search failed:', err);
    return [];
  }
}
